/**
 * WebPOS Scanner implementation to support scanning within the Griffin hybrid app.
 *
 * Copyright 2015 LightSpeed Retail. All rights reserved.
 * Created by kevinford on 15-01-07.
 */

$(() => {
  function Scanner() {
    window.StencilWebAPI.ScannerBase.call(this);
  }

  Scanner.prototype = Object.create(window.StencilWebAPI.ScannerBase.prototype);
  Scanner.prototype.constructor = Scanner;

  /**
   * Called by griffin in the event of a scan.  Attempt to set a scan target.
   * If a scan target is found, call the ScannerBase scan method to update the val
   * with the scanned code and trigger an 'enter' keypress event on the field.
   *
   * @param code {Array}  An argument array from Griffin that contains the scanned
   *						barcode.
   */
  Scanner.prototype.scan = function(code) {
    var reactPage = document.getElementById('react-page');
    var iframeEl = reactPage ? reactPage.getElementsByTagName('iframe')[0] : null;

    if (window.submit2DBarcodeScan) {
      // Scanning a 2D barcode on the register's RR modal
      window.submit2DBarcodeScan(code[0]);
    } else if (window.isReactPage && iframeEl) {
      // Scanning a 1D barcode on the RR app
      iframeEl.contentWindow.postMessage(
        {
          type: 'barcodeScan',
          payload: { barcode: code[0] },
        },
        '*'
      );
    } else {
      var selector = this._determineSelectorFromScanCode(code[0]);
      if (this._scanTargetFieldFound(selector)) {
        window.StencilWebAPI.ScannerBase.prototype.scan.call(this, code);

        if (
          this._$scanTargetField &&
          this._$scanTargetField.length &&
          typeof this._$scanTargetField[0].onchange === 'function'
        ) {
          this._$scanTargetField.trigger('change');
        }

        this._pressEnterKey();
      }
    }
  };

  /**
   * ScannerBase sets the val of the scanTarget field.  Trigger a keypress 'enter'
   * event on the current scanTargetField.
   *
   * @private
   */
  Scanner.prototype._pressEnterKey = function() {
    var enterkey = $.Event('keypress');
    enterkey.which = 13; // 13 corresponds to the 'enter' key
    enterkey.keyCode = 13;
    enterkey.key = 'Enter';

    if (!this._submitItemBarcode()) {
      this._$scanTargetField.trigger(enterkey);
    }
  };

  Scanner.prototype._submitItemBarcode = function() {
    var barcodeInput = $('.itembarcode:visible');
    var barcodeSubmit = $('.barcodesubmit:visible');

    if ($(document.activeElement).hasClass('scanner-no-submit')) {
      return true;
    }

    if (document.activeElement !== document.body || !barcodeInput.length || !barcodeSubmit.length) {
      return false;
    }

    if (document.activeElement === document.body || barcodeInput.is(':focus')) {
      barcodeSubmit.trigger('click');
    }

    return true;
  };

  /**
   * Searches for a scan field to set as the current scan target. In priority order,
   * set a focused text field, or a currently visible 'barcode' field.
   * If there is no field to place a scanned barcode, set scan target to null.
   *
   * @param selector {String} - Class selector of input(s) to look for.
   *
   * @returns {Boolean}  Whether or not a scanTargetField was found and set.
   * @private
   */
  Scanner.prototype._scanTargetFieldFound = function(selector) {
    if (this._focusedElementFound()) {
      return true;
    }
    if (this._savedScanTargetInputFound(selector)) {
      return true;
    }
    if (this._newScanTargetInputFound(selector)) {
      return true;
    }

    return false;
  };

  /**
   *	Checks the currently focused element. "<body>" is often the focused element.
   *  So check to see if the focused element is an <input type="text"> element.
   *  If it is,  than that is the scan target.
   *
   *  @returns {Boolean}  If a scan target was set.
   */
  Scanner.prototype._focusedElementFound = function() {
    var $focusedElement = $(document.activeElement);
    if ($focusedElement.is(':input') && $focusedElement.prop('type') === 'text') {
      this._$scanTargetField = $focusedElement;
      return true;
    }
    return false;
  };

  /**
   *	Check to see if we already found a currently visible barcode input field.
   *	If there is one, set that as the scan target.
   *
   *  @param selector {String} - Class selector of input(s) to look for.
   *
   *  @returns {Boolean}  If a scan target was set.
   */
  Scanner.prototype._savedScanTargetInputFound = function(selector) {
    if (this._inputFields[selector] && this._inputFields[selector].filter(':visible').length) {
      this._$scanTargetField = this._inputFields[selector].filter(':visible');
      return true;
    }
    return false;
  };

  /**
   *	Check the DOM for barcode inputs.  Store all the found inputs to speed
   *	up subsequent scans.  Set the currently visible one as the scan target.
   *
   *  @returns {Boolean}  If a scan target was set.
   */
  Scanner.prototype._newScanTargetInputFound = function(selector) {
    var $scanFields = $(selector);
    if ($scanFields.length && $scanFields.filter(':visible').length) {
      this._setInputFields(selector, $scanFields);
      this._$scanTargetField = $scanFields.filter(':visible');
      return true;
    } else {
      this._$scanTargetField = null;
      return false;
    }
  };

  /**
   * Determine the type of code scanned, and the proper input field to
   * look for, with a series of regex tests.  Default selector to
   * 'itembarcode' if not otherwise set since this is by far the most
   * common type.
   *
   *@param code {string} A barcode string.
   *@private
   */
  Scanner.prototype._determineSelectorFromScanCode = function(scanCode) {
    var item_r = /^21([0-9]{10,11})$/;
    var receipt_r = /^22([0-9]{10,11})$/;
    var giftcard_r = /^(23|4)([0-9]{10,11})$/;
    var customer_r = /^24([0-9]{10,11})$/;
    var workorder_r = /^25([0-9]{10,11})$/;

    // we assume a non MerchantOS system barcode an item UPC/EAN etc
    var selector = '.itembarcode';
    if (item_r.test(scanCode)) {
      selector = '.itembarcode';
    } else if (receipt_r.test(scanCode)) {
      selector = '.receiptbarcode';
    } else if (giftcard_r.test(scanCode)) {
      selector = '.giftcardbarcode';
    } else if (customer_r.test(scanCode)) {
      selector = '.customerbarcode';
    } else if (workorder_r.test(scanCode)) {
      selector = '.workorderbarcode';
    }

    return selector;
  };
  window.Scanner = Scanner;
});
